export function diffItems<T>(
  oldItems: T[],
  newItems: T[],
  getKey: (item: T) => string,
): { added: T[]; removed: T[] } {
  const oldKeys = new Set(oldItems.map(getKey));
  const newKeys = new Set(newItems.map(getKey));
  return {
    added: newItems.filter(item => !oldKeys.has(getKey(item))),
    removed: oldItems.filter(item => !newKeys.has(getKey(item))),
  };
}

export function describeCountChange(
  oldCount: number,
  newCount: number,
  singular: string,
): string | null {
  if (newCount > oldCount) {
    const count = newCount - oldCount;
    return `Added ${count} ${singular}${count > 1 ? 's' : ''}`;
  }
  if (oldCount > newCount) {
    const count = oldCount - newCount;
    return `Removed ${count} ${singular}${count > 1 ? 's' : ''}`;
  }
  return null;
}
